import './underline.css'; // Import regular stylesheet

export default class Underline {

    /**
   * Class name for term-tag
   *
   * @type {string}
   */
    static get CSS() {
        return 'cdx-underline';
    };

    /**
     * @param {{api: object}}  - Editor.js API
     */
    constructor({ api }) {
        this.api = api;
        this.button = null;

        this.commandName = 'underline';

        /**
         * CSS classes
         */
        this.iconClasses = {
            base: this.api.styles.inlineToolButton,
            active: this.api.styles.inlineToolButtonActive
        };
    }

    /**
     * Specifies Tool as Inline Toolbar Tool
     *
     * @return {boolean}
     */
    static get isInline() {
        return true;
    }

    /**
     * Create button element for Toolbar
     *
     * @return {HTMLElement}
     */
    render() {
        this.button = document.createElement('button');
        this.button.type = 'button';
        this.button.classList.add(this.iconClasses.base);
        this.button.innerHTML = this.toolboxIcon;

        return this.button;
    }

    /**
     * Wrap/Unwrap selected fragment
     *
     * @param {Range} range - selected fragment
     */
    surround(range) {
        document.execCommand(this.commandName);
    }

    /**
     * Check and change Term's state for current selection
     */
    checkState(selection) {
        const isActive = document.queryCommandState(this.commandName);

        this.button.classList.toggle(this.iconClasses.active, isActive);
        return isActive;
    }

    /**
     * Get Tool icon's SVG
     * @return {string}
     */
    get toolboxIcon() {
        return `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"><path d="M0 0h24v24H0z" fill="none"/><path d="M12 17c3.31 0 6-2.69 6-6V3h-2.5v8c0 1.93-1.57 3.5-3.5 3.5S8.5 12.93 8.5 11V3H6v8c0 3.31 2.69 6 6 6zm-7 2v2h14v-2H5z"/></svg>`;
    }

    /**
     * Sanitizer rule
     * @return {{u: {class: string}}}
     */
    static get sanitize() {
        return {
            u: {},
        };
    }
}